// Plugins
import { registerPlugins } from './plugins';
import { library, config } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { createSentryPiniaPlugin } from "@sentry/vue";
import { createPinia } from 'pinia'

import * as Sentry from "@sentry/vue";

const pinia = createPinia()

pinia.use(createSentryPiniaPlugin());


import {
  faAlbumCollection,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faArrowDownAZ,
  faArrowDownShortWide,
  faArrowDownWideShort,
  faArrowDownZA,
  faBackward,
  faBackwardStep,
  faBookOpen,
  faChevronDown,
  faChevronUp,
  faChevronLeft,
  faChevronRight,
  faChevronsDown,
  faChevronsLeft,
  faChevronsRight,
  faChevronsUp,
  faCirclePlay,
  faCircleXmark,
  faClockRotateLeft,
  faExclamationTriangle,
  faFileBracketsCurly,
  faFilePdf,
  faForward,
  faForwardStep,
  faHome,
  faLeftToLine,
  faListMusic,
  faMagnifyingGlassMusic,
  faMusic,
  faPlay,
  faRightToLine,
  faSearch,
  faStop,
  faStopwatch,
  faTriangleExclamation,

} from '@fortawesome/sharp-duotone-regular-svg-icons';

import App from './App.vue'

import { createApp } from 'vue'

const app = createApp(App)
import router from './router'

Sentry.init({
  app,
  dsn: "https://7f903631be6ed6604921fa899aa29ee2@aramryu.com/5",
  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/vue/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration(),
    Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] })
  ],
  // Enable logs to be sent to Sentry
  enableLogs: true,
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

library.add(
  faAlbumCollection,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faArrowDownAZ,
  faArrowDownShortWide,
  faArrowDownWideShort,
  faArrowDownZA,
  faBackward,
  faBackwardStep,
  faBookOpen,
  faChevronDown,
  faChevronUp,
  faChevronLeft,
  faChevronRight,
  faChevronsDown,
  faChevronsLeft,
  faChevronsRight,
  faChevronsUp,
  faCirclePlay,
  faCircleXmark,
  faClockRotateLeft,
  faExclamationTriangle,
  faFileBracketsCurly,
  faFilePdf,
  faForward,
  faForwardStep,
  faHome,
  faLeftToLine,
  faListMusic,
  faMagnifyingGlassMusic,
  faMusic,
  faPlay,
  faRightToLine,
  faSearch,
  faStop,
  faStopwatch,
  faTriangleExclamation,
)

config.showMissingIcons = true;
// config.familyDefault = 'sharp-duotone';
// config.styleDefault = 'regular';

app.component('FontAwesomeIcon', FontAwesomeIcon) // Register component globally

registerPlugins(app)


app.use(pinia).mount('#app')
